import { Table } from 'antd';
import { couponTypeDictionary } from '../../../../constants';
import { formatPrice } from '../../../../util/formatPrice';

export const CouponPopoverProducts = ({ coupon }) => {
  const columns = [
    {
      title: 'Producto',
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: 'Precio Regular',
      dataIndex: 'regularPrice',
      key: 'regularPrice',
      align: 'right',
      width: 120,
    },
    {
      title: 'Descuento',
      dataIndex: 'discount',
      key: 'discount',
      align: 'center',
      width: 100,
    },
    {
      title: 'Precio Final',
      dataIndex: 'finalPrice',
      key: 'finalPrice',
      align: 'right',
      width: 120,
    },
  ];

  const getProductsData = () => {
    const data = [];

    if (coupon.product) {
      const price = coupon.product.salePrice || 0;
      const discount = coupon.discount || 0;
      const finalPrice = price - price * (discount / 100);

      data.push({
        key: 'individual-product',
        name: coupon.product.name,
        regularPrice: formatPrice(price),
        discount: `${discount}%`,
        finalPrice: formatPrice(finalPrice),
      });
    }

    if (coupon.treatment) {
      const price = coupon.treatment.price || 0;
      const discount = coupon.discount || 0;
      const finalPrice = price - price * (discount / 100);

      data.push({
        key: 'individual-treatment',
        name: coupon.treatment.name,
        regularPrice: formatPrice(price),
        discount: `${discount}%`,
        finalPrice: formatPrice(finalPrice),
      });
    }

    if (coupon.products && coupon.products.length) {
      coupon.products.forEach((product, index) => {
        const price = product.salePrice || 0;
        const discount = coupon.discount || 0;
        const finalPrice = price - price * (discount / 100);

        data.push({
          key: `product-${index}`,
          name: product.name,
          regularPrice: formatPrice(price),
          discount: `${discount}%`,
          finalPrice: formatPrice(finalPrice),
        });
      });
    }

    if (coupon.treatments && coupon.treatments.length) {
      coupon.treatments.forEach((treatment, index) => {
        const price = treatment.price || 0;
        const discount = coupon.discount || 0;
        const finalPrice = price - price * (discount / 100);

        data.push({
          key: `treatment-${index}`,
          name: treatment.name,
          regularPrice: formatPrice(price),
          discount: `${discount}%`,
          finalPrice: formatPrice(finalPrice),
        });
      });
    }

    if (coupon.multiple && coupon.multiple.length) {
      coupon.multiple.forEach((item, index) => {
        const price =
          couponTypeDictionary[item.type] === 'Tratamiento'
            ? item.treatment?.price
            : item.product?.salePrice;

        const discount = item.discount || coupon.discount || 0;
        const finalPrice = price - price * (discount / 100);

        data.push({
          key: `multiple-${index}`,
          name:
            couponTypeDictionary[item.type] === 'Tratamiento'
              ? item.treatment?.name
              : item.product?.name,
          regularPrice: formatPrice(price),
          discount: `${discount}%`,
          finalPrice: formatPrice(finalPrice),
        });
      });
    }

    return data;
  };

  const data = getProductsData();

  return (
    <Table
      columns={columns}
      dataSource={data}
      size="small"
      pagination={false}
      scroll={{ x: 500 }}
    />
  );
};
